import { addError } from "@wayflyer/blackbox-fe";
import { useNavigate } from "react-router";
import { useSpaNavigate } from "shared-ui";
import { useCustomerAppConfig } from "@wayflyer/undercarriage";

import { useCreateFundingApplicationMutation } from "../queries/funding-application/queries";

export const useApplyForFunds = () => {
  const {
    data: { customerDomain, customerUuid },
  } = useCustomerAppConfig();
  const standardNavigate = useNavigate();
  const { navigate: companyCreationNavigate } = useSpaNavigate("CompanyCreation");
  const createFundingApplication = useCreateFundingApplicationMutation(customerDomain, customerUuid);

  const apply = () =>
    createFundingApplication
      .mutateAsync()
      .then(({ data }) => {
        if (data.subStage === "/revenue") {
          // Todo: navigate directly to /funding/application/revenue once OBN-202 is complete
          companyCreationNavigate("revenue");
        } else if (data.subStage) {
          standardNavigate(`/${customerDomain}/funding/application${data.subStage}`);
        }
      })
      .catch((error) => {
        // Error is already handled by the mutation's onError callback
        // This catch prevents unhandled promise rejection warnings
        addError("Failed to create funding application:", error);
      });

  return { apply, isPending: createFundingApplication.isPending };
};
